import { baseUrl } from "../../url";
import styles from "./OrderAlarm.module.css";
import { useEffect, useState, useContext } from "react";
import { AuthContext, AuthContextType } from "../../Auth";
import { useNavigate } from "react-router-dom";
import { Button } from "@mui/material";

type orderAlarm = {
  alarm_id: number;
  office: string;
  schedule: { hour: string; minutes: string };
  email: string;
  is_enabled: boolean;
};

export default function OrderAlarm() {
  const [selectedHour, setSelectedHour] = useState<string[]>([]);
  const [selectedMinute, setSelectedMinute] = useState<string[]>([]);
  const [email, setEmail] = useState<string[]>([]);
  const [alarmSettings, setAlarmSettings] = useState<orderAlarm[]>([]);
  const [enable, setEnable] = useState<boolean[]>([]);
  const { setAuth } = useContext(AuthContext) as AuthContextType;
  const navigate = useNavigate();

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const response = await fetch(`${baseUrl}/checkAuth`, {
          method: "POST",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
        });
        const data = await response.json();
        if (!data.result) {
          console.log("Not authenticated");
          setAuth({
            username: null,
            isAuthenticated: false,
            office: undefined,
            authority: "user",
          });
          return navigate("/login");
        }
        const response2 = await fetch(`${baseUrl}/getusersdata`, {
          method: "POST",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ username: data.username }),
        });
        const data2 = await response2.json();
        console.log(
          "Authenticated user:",
          data.username,
          "Office:",
          data2.office,
          "Authority:",
          data2.authority
        );
        setAuth({
          username: data.username,
          isAuthenticated: true,
          office: data2.office,
          authority: data2.authority,
        });
      } catch (error) {
        console.error(error);
      }
    };
    checkAuth();
  }, [navigate, setAuth]);

  useEffect(() => {
    const fetchAlarm = async () => {
      const response = await fetch(`${baseUrl}/getorderalarm`, {
        method: "GET",
        credentials: "include",
      });
      const data = await response.json();
      for (let i = 0; data.length > i; i++) {
        if (data[i].schedule) {
          const cronString = data[i].schedule;
          const humanReadableFormat = (cronString: string) => {
            const parts = cronString.split(" ");
            const minutes = parts[0];
            const hours = parts[1];
            return { hour: hours, minutes: minutes };
          };
          data[i].schedule = humanReadableFormat(cronString);
        }
      }
      for (let i = 0; i < data.length; i++) {
        if (data[i].is_enabled === 1) {
          data[i].is_enabled = true;
        } else {
          data[i].is_enabled = false;
        }
      }
      console.log(data);
      const hourArray = data.map((item: orderAlarm) =>
        item.schedule ? item.schedule.hour : ""
      );
      setSelectedHour(hourArray);
      const minuteArray = data.map((item: orderAlarm) =>
        item.schedule ? `0${+item.schedule.minutes}`.slice(-2) : ""
      );
      setSelectedMinute(minuteArray);
      const emailArray = data.map((item: orderAlarm) =>
        item.email ? item.email : ""
      );
      setEmail(emailArray);
      setAlarmSettings(data);
      setEnable(data.map((item: orderAlarm) => item.is_enabled));
    };
    fetchAlarm();
  }, []);

  const hour = [
    "7",
    "8",
    "9",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
  ];
  const minutes = [
    "00",
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "20",
    "21",
    "22",
    "23",
    "24",
    "25",
    "26",
    "27",
    "28",
    "29",
    "30",
    "31",
    "32",
    "33",
    "34",
    "35",
    "36",
    "37",
    "38",
    "39",
    "40",
    "41",
    "42",
    "43",
    "44",
    "45",
    "46",
    "47",
    "48",
    "49",
    "50",
    "51",
    "52",
    "53",
    "54",
    "55",
    "56",
    "57",
    "58",
    "59",
  ];

  const handleHour = (
    e: React.ChangeEvent<HTMLSelectElement>,
    index: number
  ) => {
    const newHour = [...selectedHour];
    newHour[index] = e.target.value;
    setSelectedHour(newHour);
  };
  const handleMinute = (
    e: React.ChangeEvent<HTMLSelectElement>,
    index: number
  ) => {
    const newMinute = [...selectedMinute];
    newMinute[index] = e.target.value;
    setSelectedMinute(newMinute);
  };
  const handleEnable = (
    e: React.ChangeEvent<HTMLInputElement>,
    index: number
  ) => {
    const isChecked = e.target.checked;
    const updatedEnable = enable ? [...enable] : [];
    updatedEnable[index] = isChecked;
    setEnable(updatedEnable);
  };

  const handleEmail = (
    e: React.ChangeEvent<HTMLInputElement>,
    index: number
  ) => {
    const newEmail = [...email];
    newEmail[index] = e.target.value;
    setEmail(newEmail);
  };

  return (
    <div className={styles.div}>
      <h2 className={styles.h2}>発注アラーム設定</h2>
      <p>
        在庫不足分が¥30,000を超えた発注先の情報をメールで通知する機能です。支店ごとの在庫管理担当に送信されます。
      </p>
      <div className={styles.scroll}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th className={styles.th}>支店</th>
              <th className={styles.th}>有効にする</th>
              <th className={styles.th}>メール発送時刻</th>
              <th className={styles.th}>担当者メールアドレス</th>
            </tr>
          </thead>
          <tbody>
            {alarmSettings.map((item, index) => (
              <tr key={index}>
                <td className={styles.td}>{item.office}</td>
                <td className={styles.td}>
                  {enable ? (
                    <input
                      type="checkbox"
                      checked={enable[index]}
                      onChange={(e) => handleEnable(e, index)}
                    />
                  ) : (
                    ""
                  )}
                </td>
                <td className={styles.td}>
                  <label htmlFor="hour" className={styles.label}>
                    実行時刻
                    <select
                      name="hour"
                      id="hour"
                      className={styles.select}
                      onChange={(e) => handleHour(e, index)}
                      value={selectedHour[index]}
                      disabled={!enable[index]}
                    >
                      <option value="" hidden>
                        --
                      </option>
                      {hour.map((item, index) => (
                        <option key={index} value={item}>
                          {item}
                        </option>
                      ))}
                    </select>
                    :
                    <select
                      name="minute"
                      id="minute"
                      className={styles.select}
                      onChange={(e) => handleMinute(e, index)}
                      value={selectedMinute[index]}
                      disabled={!enable[index]}
                    >
                      <option value="" hidden>
                        --
                      </option>
                      {minutes.map((item, index) => (
                        <option key={index} value={item}>
                          {item}
                        </option>
                      ))}
                    </select>
                  </label>
                </td>
                <td className={styles.td}>
                  <input
                    type="text"
                    onChange={(e) => handleEmail(e, index)}
                    value={email[index]}
                    disabled={!enable[index]}
                    className={styles.input}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <Button variant="contained" size="large" sx={{ margin: 3 }}>
        変更を反映する
      </Button>
    </div>
  );
}
